import firebase from "firebase";
import { database } from './firebase.js'

export async function loadUserInfo(uid) {
  try {
    let result = await database.ref(`users/${uid}/`).once('value');
    result = result.val();
    if (result) return result
  }
  catch (err) {
    console.error(err);
    return Promise.reject(err);
  }
}

export async function deleteUserInfo(uid) {
  try {
    const result = await database.ref(`users`).update({
      [uid]: null
    });

    return result
  } catch (err) {
    console.error(err);
    return Promise.reject(err);
  }
}

export async function uploadUserInfo(obj, uid) {
  try {
    const result = await database.ref(`users/${uid}/`).update(obj);

    return result
  }
  catch (err) {
    console.error(err);
    return Promise.reject(err);
  }
}

export async function loadUserData(userAccount) {
  let user = userAccount || await firebase.auth().currentUser;

  return await user && user.getIdTokenResult().then((result) => {
    return result.claims
  })
}

export async function loadAllUsers() {
  let users = await database.ref(`users`).once('value').then(res => res.val());
  let usersArray = [];
  for (let user in users) {
    if (users[user] && users[user].Uid) {
      users[user].Uid = user
      usersArray.push(users[user])
    }
  }

  return usersArray
}

export async function saveEvent(uid, newSavedEventList) {

  try {
    const result = await database.ref(`users/${uid}`).update({ savedEvents: newSavedEventList });

    return result
  } catch (err) {
    console.error(err);
    return Promise.reject(err);
  }
}

export async function favoriteChat(uid, favoriteChats) {
  try {
    const result = await database.ref(`users/${uid}`).update({ favoriteChats: favoriteChats });

    return result
  } catch (err) {
    console.error(err);
    return Promise.reject(err);
  }
}

export async function getUserCard(cardId) {
  try {
    let result = await database.ref(`cards/${cardId}`).once('value');
    result = result.val();

    if (result) return result;
  } catch (err) {
    console.error(err);
    return Promise.reject(err);
  }
}





// WEBPACK FOOTER //
// ./src/services/firebase/user.js